import { render, staticRenderFns } from "./signatrue.vue?vue&type=template&id=560f5697&scoped=true&"
import script from "./signatrue.vue?vue&type=script&lang=ts&"
export * from "./signatrue.vue?vue&type=script&lang=ts&"
import style0 from "./signatrue.vue?vue&type=style&index=0&id=560f5697&lang=less&scoped=true&"
import style1 from "./signatrue.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560f5697",
  null
  
)

export default component.exports